import { MediaLimitsIndicationView } from '@app/modules/social-export/lib/format-media-limits-indication';
import { Alert } from '@mui/material';

type MediaLimitsAlertProps = {
  indication: MediaLimitsIndicationView;
};

/**
 * Long media-limits display: MUI Alert with severity based on indication kind.
 */
export function MediaLimitsAlert({ indication }: MediaLimitsAlertProps) {
  const severity =
    indication.kind === 'blocked'
      ? 'error'
      : indication.kind === 'needs_transcoding'
        ? 'warning'
        : 'info';

  return (
    <Alert severity={severity} sx={{ mb: 2 }}>
      {indication.message}
    </Alert>
  );
}
